import React, { createContext, useContext } from "react";

interface ShadowDomContextValue {
  shadowRoot: ShadowRoot | null;
  host: HTMLElement | null;
}

const ShadowDomContext = createContext<ShadowDomContextValue>({
  shadowRoot: null,
  host: null,
});

interface ShadowDomProviderProps {
  shadowRoot: ShadowRoot;
  host: HTMLElement;
  children: React.ReactNode;
}

export const ShadowDomProvider: React.FC<ShadowDomProviderProps> = ({
  shadowRoot,
  host,
  children,
}) => {
  return (
    <ShadowDomContext.Provider value={{ shadowRoot, host }}>
      {children}
    </ShadowDomContext.Provider>
  );
};

export const useShadowDom = (): ShadowDomContextValue => {
  return useContext(ShadowDomContext);
};

